import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CdwUserOptionComponent } from '@cdw-ae/common-ui-components-user-profile-card';
import { CdwSearchInputComponent } from './cdw-search-input/cdw-search-input.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    CdwIconModule,
    CdwUserOptionComponent,
  ],
  declarations: [CdwSearchInputComponent],
  exports: [CdwSearchInputComponent],
})
export class CommonUiComponentsSearchInputModule {}
